import { render, staticRenderFns } from "./addMembersForm.vue?vue&type=template&id=bd2b2710&lang=html&"
import script from "./addMembersForm.vue?vue&type=script&lang=ts&"
export * from "./addMembersForm.vue?vue&type=script&lang=ts&"
import style0 from "./addMembersForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports